export const SPACE_TYPE_META = Object.freeze({
    courses: {
        label: 'Course',
        pluralLabel: 'courses',
        createType: 'class',
        spaceTypeEnumKey: 'EDUCATION_SPACE',
        icon: 'mdi-school-outline',
        buttonColor: 'orange lighten-5',
        iconColorClass: 'orange--text text--darken-4',
        spacesStateKey: 'educationSpaces'
    },
    projects: {
        label: 'Project',
        pluralLabel: 'projects',
        createType: 'research',
        spaceTypeEnumKey: 'RESEARCH_SPACE',
        icon: 'mdi-beaker-outline',
        buttonColor: 'cyan lighten-5',
        iconColorClass: 'cyan--text text--darken-3',
        spacesStateKey: 'researchSpaces'
    },
    datasets: {
        label: 'Dataset',
        pluralLabel: 'datasets',
        createType: 'dataset',
        spaceTypeEnumKey: 'VENDOR_SPACE',
        icon: 'mdi-database-outline',
        buttonColor: 'purple lighten-5',
        iconColorClass: 'purple--text text--darken-3',
        spacesStateKey: 'datasetSpaces'
    }
})

export const SPACE_TYPE_ORDER = Object.freeze(['courses', 'projects', 'datasets'])

export const DEFAULT_SPACE_TYPE_META = Object.freeze({
    label: 'Space',
    pluralLabel: 'spaces',
    createType: 'class',
    spaceTypeEnumKey: null,
    icon: 'mdi-shape-outline',
    buttonColor: 'grey lighten-4',
    iconColorClass: 'grey--text text--darken-1',
    spacesStateKey: null
})
